export class StrRtnReq {
    storeReturnId: number;
}